import { EnteringSpace } from './EnteringSpace';
import React, { useState } from 'react';
import GamePiece from '../GamePiece';
import Rack from '../Rack';
import PlayerSection from './PlayerSection';
import GridSquare from './GridSquare';
import { BLUE, CAPTURED, RED } from '../../constants';
import { getNextMove, getPiece } from '../../game/helpers';
import {
  GameContainer,
  BoardContainer,
  BoardContainerGrid,
  BoardGridTray,
} from './styles';

const Board = ({ G, ctx, moves, events }) => {
  const [selected, setSelected] = useState(null);

  const pieceClickHandler = (id) => {
    setSelected(null);
    return moves.movePiece(id);
  };
  const mouseEnterHandler = (id) => {
    const piece = getPiece(G.pieces, id);
    if (ctx.currentPlayer !== piece.color) return;

    return setSelected(getNextMove(piece));
  };
  const mouseLeaveHandler = () => setSelected(null);

  const getPieceById = (pieceId) => {
    if (!pieceId) return null;
    const { id, color, moveSet } = getPiece(G.pieces, pieceId);
    const atLastPosition = G.cells[moveSet[moveSet.length - 2]] === pieceId;
    const inEnteringSpace = G.enteringSpace[color].includes(pieceId);

    const propsObj = {
      id,
      color,
      moveSet,
      inEnteringSpace,
      atLastPosition: atLastPosition && ctx.currentPlayer === color,
      cycleRackHandler: () => {
        moves.cycleToRack(id);
        events.endTurn();
      },
      cycleSpaceHandler: () => {
        moves.cycleToEnteringSpace(id);
        events.endTurn();
      },
      clickHandler: pieceClickHandler,
      handleMouseEnter: mouseEnterHandler,
      handleMouseLeave: mouseLeaveHandler,
    };

    return <GamePiece key={id} {...propsObj} />;
  };

  const getCapturedPieces = (color) => {
    const pieces = G.pieces.filter(
      (piece) => piece.color === color && piece.currentPos === CAPTURED
    );
    return !pieces ? null : pieces.map((piece) => getPieceById(piece.id));
  };

  const getEnteringSpacePieces = (color) =>
    G.enteringSpace[color].map((id) => getPieceById(id));

  return (
    <GameContainer>
      <PlayerSection G={G} ctx={ctx} player={RED} />
      <BoardContainer>
        <Rack
          color={BLUE}
          pieces={G.pieces}
          handler={pieceClickHandler}
          handleMouseEnter={mouseEnterHandler}
          handleMouseLeave={mouseLeaveHandler}
        />
        <BoardContainerGrid>
          <EnteringSpace
            color={BLUE}
            selected={selected}
            enteringSpacePieces={getEnteringSpacePieces(BLUE)}
          />
          {G.cells[0] ? (
            <GridSquare highlight={selected === 0}>
              {getPieceById(G.cells[0])}
            </GridSquare>
          ) : (
            <GridSquare highlight={selected === 0} dot={BLUE}></GridSquare>
          )}
          {G.cells[1] ? (
            <GridSquare highlight={selected === 1}>
              {getPieceById(G.cells[1])}
            </GridSquare>
          ) : (
            <GridSquare highlight={selected === 1} dot={BLUE}></GridSquare>
          )}
          {G.cells[2] ? (
            <GridSquare highlight={selected === 2}>
              {getPieceById(G.cells[2])}
            </GridSquare>
          ) : (
            <GridSquare highlight={selected === 2} dot={BLUE}></GridSquare>
          )}
          <BoardGridTray team={RED}>{getCapturedPieces(RED)}</BoardGridTray>
          <BoardGridTray team={BLUE}>{getCapturedPieces(BLUE)}</BoardGridTray>
          <GridSquare highlight={selected === 3}>
            {getPieceById(G.cells[3])}
          </GridSquare>
          <GridSquare highlight={selected === 4}>
            {getPieceById(G.cells[4])}
          </GridSquare>
          <GridSquare highlight={selected === 5}>
            {getPieceById(G.cells[5])}
          </GridSquare>
          <GridSquare highlight={selected === 6}>
            {getPieceById(G.cells[6])}
          </GridSquare>
          <GridSquare highlight={selected === 7}>
            {getPieceById(G.cells[7])}
          </GridSquare>
          <GridSquare highlight={selected === 8}>
            {getPieceById(G.cells[8])}
          </GridSquare>
          {G.cells[9] ? (
            <GridSquare>{getPieceById(G.cells[9])}</GridSquare>
          ) : (
            <GridSquare highlight={selected === 9} dot={RED}></GridSquare>
          )}
          {G.cells[10] ? (
            <GridSquare highlight={selected === 10}>
              {getPieceById(G.cells[10])}
            </GridSquare>
          ) : (
            <GridSquare highlight={selected === 10} dot={RED}></GridSquare>
          )}
          {G.cells[11] ? (
            <GridSquare highlight={selected === 11}>
              {getPieceById(G.cells[11])}
            </GridSquare>
          ) : (
            <GridSquare highlight={selected === 11} dot={RED}></GridSquare>
          )}
          <EnteringSpace
            color={RED}
            selected={selected}
            enteringSpacePieces={getEnteringSpacePieces(RED)}
          />
        </BoardContainerGrid>
        <Rack
          color={RED}
          pieces={G.pieces}
          handler={pieceClickHandler}
          handleMouseEnter={mouseEnterHandler}
          handleMouseLeave={mouseLeaveHandler}
        />
      </BoardContainer>
      <PlayerSection G={G} ctx={ctx} player={BLUE} />
    </GameContainer>
  );
};

export default Board;
